module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "100",
      "tablet": "20"
    }
  }), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "40",
      "width": "100",
      "tablet": "60"
    }
  }, [_c('create-question', {
    staticClass: "animated fadeInUp"
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "30",
      "width": "100",
      "tablet": "20"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748dd2e8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Questions/QuestionCreate.vue
// module id = 3784
// module chunks = 1